import type { RecommendationType, ScoringCategory } from "../types/visibility";

// Compact labels for the chip on each recommendation card. Scoring pillars, plus the
// crawlability gate that sits outside the AEO/GEO/SXO/AIO blend and carries the
// deterministically injected technical suggestions.
//
// AII is spelled out rather than left as its acronym: "AII" and "All" are all but
// indistinguishable in a sans-serif face, which reads as a bug next to a filter whose
// default option is "All Categories".
export const SCORING_CATEGORY_LABELS: Record<ScoringCategory, string> = {
  AEO: "AEO",
  GEO: "GEO",
  SXO: "SXO",
  AIO: "AIO",
  AII: "AI Integration",
  ai_crawlability: "AI Crawlability",
};

// Dropdown labels match the chips, except AII also carries the advisory caveat the
// Detailed Analysis tab shows ("Advisory — not part of your overall score"): AII
// recommendations cannot move the overall score, unlike every other option here.
export const SCORING_CATEGORY_FILTER_LABELS: Record<ScoringCategory, string> = {
  ...SCORING_CATEGORY_LABELS,
  AII: "AI Integration (Advisory)",
};

export const SCORING_CATEGORY_COLORS: Record<ScoringCategory, string> = {
  AEO: "blue",
  GEO: "purple",
  SXO: "emerald",
  AIO: "orange",
  AII: "neutral",
  ai_crawlability: "neutral",
};

// Card chip and dropdown option read from the same map, so a type the API adds later
// falls back to its raw value everywhere rather than being relabelled as the other one.
export const RECOMMENDATION_TYPE_LABELS: Record<RecommendationType, string> = {
  technical: "Technical",
  content: "Content",
};

// Type and Scoring Category filter options, derived from the label maps above so every screen
// with these two axes — the AI Audit tab, and the Visibility report's "What to do" list — offers
// the same dropdown contents in the same order.
export const RECOMMENDATION_TYPE_OPTIONS = Object.entries(RECOMMENDATION_TYPE_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export const SCORING_CATEGORY_OPTIONS = Object.keys(SCORING_CATEGORY_LABELS).map((value) => ({
  value,
  label: SCORING_CATEGORY_FILTER_LABELS[value as ScoringCategory],
}));
